import { simpleQuery } from "./utils";

// Kept out of Pricing/utils: the main menu polls this count on every page, and
// Pricing/utils pulls the Alert filter tree (and its date pickers) with it.
export const listWorkflowUpdatesError = async () => {
  return simpleQuery("/api/workflow-updates/error-count/", { method: "GET" });
};
